import { Modal as AntdModal } from "antd";

import styled from "styled-components";

export const Modal: typeof AntdModal = styled(AntdModal)`
  .ant-modal-content {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;

    .ant-modal-close-icon {
      color: ${({ theme }) => theme.token.colorTextLightSolid};
    }

    .ant-modal-header {
      background-color: ${({ theme }) => theme.token.colorPrimary};
      padding: ${({ theme }) =>
        `${theme.token.paddingMD}px ${theme.token.paddingLG}px ${theme.token.paddingSM}px`};
      .ant-modal-title {
        color: ${({ theme }) => theme.token.colorTextLightSolid};
      }
    }

    .ant-modal-body,
    .ant-modal-footer {
      padding: ${({ theme }) => `0 ${theme.token.paddingLG}px`};
    }
  }
`;
